import { useMap } from "react-leaflet";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { setSourceLocationJustSet } from "../../redux/map/map.actions";
import {
  selectMapLevel,
  selectMapSourceLoacationJustSet,React
} from "../../redux/map/map.selectors";
import { selectNewRequestSourceLocation } from "../../redux/newRequest/newRequest.selectors";

const SourceLocationJustSet = ({
  selectMapSourceLoacationJustSet,
  selectNewRequestSourceLocation,
  selectMapLevel,
}) => {
  const map = useMap();

  if (selectMapSourceLoacationJustSet && selectMapLevel === 1) {
    map.flyTo(
      {
        lat: selectNewRequestSourceLocation.lat + 0.002,
        lng: selectNewRequestSourceLocation.long + 0.002,
      },
      map.getZoom() - 1
    );
    setSourceLocationJustSet(false);
    return null;
    // alert("111");
  }

  return null;
};

const mapStateToProps = createStructuredSelector({
  selectMapSourceLoacationJustSet: selectMapSourceLoacationJustSet,
  selectNewRequestSourceLocation: selectNewRequestSourceLocation,
  selectMapLevel: selectMapLevel,
});

const mapDispatchToProps = (dispatch) => ({
  setSourceLocationJustSet: (x) => dispatch(setSourceLocationJustSet(x)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SourceLocationJustSet);
